import { useFilterUtilServiceContext } from "./filter-util-service.context";

export function FilterUtilService() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterUtilServiceContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}